import sample from 'lodash/sample';

import formatMoney from './format-money';
import { image } from './image';

export const item = (data, trackingAttributes = [], truncate = false) => `
  <div class="product-item">
    <a href="${data.url}" class="block mb-4" ${trackingAttributes.join(' ')}>
      <div class="product-item__images aspect-ratio aspect-ratio--3/4">
        ${
          typeof data.image === 'object'
            ? image(data.image, 3 / 4)
            : image(data.featured_image, 3 / 4)
        }
      </div>
    </a>

    <p class="text-sm font-semibold ${truncate ? 'truncate' : ''}">${data.type}</p>
    <p class="${truncate ? 'truncate' : ''}"><a href="${data.url}">${data.title}</a></p>
    <p class="${data.price === 0 ? 'hidden' : ''}">
      <span>${formatMoney(data.price).removeTrailingZeros()}</span>
      ${
        data.price < data.compare_at_price_max
          ? `<del class="ml-2 text-gray-500">${formatMoney(
              data.compare_at_price_max,
            ).removeTrailingZeros()}`
          : ''
      }
    </p>
  </div>
`;

export const placeholderItem = (index) => {
  const widths = ['w-8', 'w-12', 'w-16', 'w-20', 'w-24'];

  return `
    <div class="product-item animate-skeleton-loading" ${
      index ? `style="animation-delay: ${index}00ms"` : ''
    }>
      <div class="mb-4">
        <div class="product-item__images aspect-ratio aspect-ratio--3/4">
          <div class="bg-gray-200 theme-blackweek:bg-[#222222]"></div>
        </div>
      </div>

      <div class="bg-gray-200 theme-blackweek:bg-[#222222] ${sample(widths)} h-3 mb-2.5"></div>
      <div class="bg-gray-300 theme-blackweek:bg-[#222222] ${sample(widths)} h-4 mb-2.5"></div>
      <div class="bg-gray-200 theme-blackweek:bg-[#222222] w-16 h-4"></div>
    </div>
  `;
};

export const searchProductItem = (data, trackingAttributes = [], truncate = false) => `
  <a
    href="${data.url}"
    data-product-link
    data-component="product-item"
    class="product-item font-body text-sm leading-4 block lg:text-base lg:leading-5"
    ${trackingAttributes.join(' ')}
    data-product-item='{"type":"${data.type}","id":${data.id},"title":"${data.title}","price":${data.price},"index":${data.index}}'
  >
    <div class="product-item__images aspect-ratio aspect-ratio--3/4 mb-2 lg:mb-3">
      ${
        typeof data.image === 'object'
          ? image(data.image, 3 / 4)
          : image(data.featured_image, 3 / 4)
      }
    </div>
    <p class="mb-0.5 lg:mb-0 ${truncate ? 'truncate' : ''}">
      ${data.title}
    </p>
    <p class="${data.price === 0 ? 'hidden' : ''}">
      <span ${data.price < data.compare_at_price_max ? "class='text-primary-sale'" : ''}>
        ${formatMoney(data.price).removeTrailingZeros()}
      </span>
      ${
        data.price < data.compare_at_price_max
          ? `<del class="ml-2 text-gray-500">${formatMoney(
              data.compare_at_price_max,
            ).removeTrailingZeros()}`
          : ''
      }
    </p>
  </a>
`;

export default {
  item,
  placeholderItem,
  searchProductItem,
};
